import { handleError } from "../../../helperFunctions";
import { BaseAPIResponse } from "../../../utils/types";
import { baseApi } from "../../api";
import {
  GetPaymentLinkQuery,
  GetPaymentLinkResponse,
  VerifyPayment,
} from "../payment/payment.type";
import {
  CooperativeFinancesQuery,
  CooperativeFinancesResponse,
  CooperativeTransactionQuery,
  CooperativeTransactionResponse,
  CooperativeWithdrawalPayload,
} from "./finances.type";

export const financesApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getCooperativeFinances: builder.query<
      CooperativeFinancesResponse,
      CooperativeFinancesQuery
    >({
      query: (params) => {
        return {
          url: `/Payment/Cooperative/Finances/Admin`,
          method: "GET",
          params: params,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, false);
        }
      },
    }),

    getCooperativeTransactionHistory: builder.query<
      CooperativeTransactionResponse,
      CooperativeTransactionQuery
    >({
      query: (params) => {
        return {
          url: `/Payment/Cooperative/Wallet/Admin`,
          method: "GET",
          params: params,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, false);
        }
      },
    }),

    getCooperativeWalletPaystackPayment: builder.mutation<
      GetPaymentLinkResponse,
      GetPaymentLinkQuery
    >({
      query: (params) => {
        return {
          url: `/Payment/Get/link`,
          method: "GET",
          params: params,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),

    verifyCooperativeWalletPayment: builder.mutation<
      BaseAPIResponse,
      VerifyPayment
    >({
      query: (payload) => {
        return {
          url: `/Payment/Cooperative/Wallet/Admin`,
          method: "POST",
          body: payload,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),

    initiateCooperativeWalletWithdrawal: builder.mutation<
      BaseAPIResponse,
      CooperativeWithdrawalPayload
    >({
      query: (payload) => {
        return {
          url: `/Withdrawal/Cooperative`,
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),
  }),
});

export const {
  useGetCooperativeFinancesQuery,
  useGetCooperativeTransactionHistoryQuery,
  useGetCooperativeWalletPaystackPaymentMutation,
  useVerifyCooperativeWalletPaymentMutation,
  useInitiateCooperativeWalletWithdrawalMutation,
} = financesApi;
